import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationsService } from '@app/core/api/services/notifications.service';
import { Notification, NotificationType, getNotificationInput } from '@app/core/api/models/notifications.model';
import { map } from 'rxjs/operators';

@Component({
    selector: 'sta-unauthenticated-layout',
    templateUrl: './unauthenticated-layout.component.html',
    styleUrls: ['./unauthenticated-layout.component.scss'],
    standalone: false
})
export class UnauthenticatedLayoutComponent implements OnInit {
  @Input() notices$!: Observable<Notification[]>;

  constructor(
    private NotificationsService: NotificationsService,

  ) { }

  ngOnInit() {

    // Load Notices via public API (x-api-key)
    const input: getNotificationInput = {
      AnnKey: 'SYS#1',
      Active: true,
      Type: NotificationType.Banner,
    };

    this.notices$ = this.NotificationsService.getNotificationsPublic(input);

  }
}
